import { GenIcon } from '../helpers/IconBase.es.js';

const MoreProductOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 3.5H9C9.27614 3.5 9.5 3.72386 9.5 4V9C9.5 9.27614 9.27614 9.5 9 9.5H4C3.72386 9.5 3.5 9.27614 3.5 9V4C3.5 3.72386 3.72386 3.5 4 3.5ZM2 4C2 2.89543 2.89543 2 4 2H9C10.1046 2 11 2.89543 11 4V9C11 10.1046 10.1046 11 9 11H4C2.89543 11 2 10.1046 2 9V4ZM4 14.5H9C9.27614 14.5 9.5 14.7239 9.5 15V20C9.5 20.2761 9.27614 20.5 9 20.5H4C3.72386 20.5 3.5 20.2761 3.5 20V15C3.5 14.7239 3.72386 14.5 4 14.5ZM2 15C2 13.8954 2.89543 13 4 13H9C10.1046 13 11 13.8954 11 15V20C11 21.1046 10.1046 22 9 22H4C2.89543 22 2 21.1046 2 20V15ZM20 3.5H15C14.7239 3.5 14.5 3.72386 14.5 4V9C14.5 9.27614 14.7239 9.5 15 9.5H20C20.2761 9.5 20.5 9.27614 20.5 9V4C20.5 3.72386 20.2761 3.5 20 3.5ZM15 2C13.8954 2 13 2.89543 13 4V9C13 10.1046 13.8954 11 15 11H20C21.1046 11 22 10.1046 22 9V4C22 2.89543 21.1046 2 20 2H15ZM15 14.5H20C20.2761 14.5 20.5 14.7239 20.5 15V20C20.5 20.2761 20.2761 20.5 20 20.5H15C14.7239 20.5 14.5 20.2761 14.5 20V15C14.5 14.7239 14.7239 14.5 15 14.5ZM13 15C13 13.8954 13.8954 13 15 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22H15C13.8954 22 13 21.1046 13 20V15Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { MoreProductOutlined };
